function Blog () {
    return (
        <div>
            <h1 className="py-64">Helloo</h1>
        </div>
    )
};

export default Blog;